import { button, folder, useControls } from 'leva'

export default function Controls(gl) {
  return useControls({
    Settings: folder({
      Rendering_Scale: {
        value: 0.75,
        max: 1,
        min: 0,
        step: 0.01,
        label: 'Resolution',
      },
      Rendering_Bounces: {
        value: 12,
        max: 20,
        min: 1,
        step: 1,
        label: 'Bounces',
      },
      Rendering_Samples: {
        value: 1,
        max: 20,
        min: 1,
        step: 1,
        label: 'FrameSamples',
      },
    }),
    Controls: folder({
      TakeScreenshot: button(() => {
        window.takeScreenshot()
      }),
    }),
  })
}
